import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import useResizeObserver from './useResizeObserver';
export const useResizeIframe = ref => {
  const changeIframeStyle = useInvokeCapability(capabilities.RESTYLE_CAP);
  const onResize = ({
    height,
    width
  }) => {
    changeIframeStyle({
      style: {
        width: `${width}px`,
        height: `${height}px`
      },
      merge: true
    });
  };
  useResizeObserver(ref, onResize);
};